export default "__VITE_ASSET__Qwkt3UZY__"